import { noop } from 'lodash';
import React, { Component } from 'react';
import { func } from 'prop-types';
import { Typography } from '@material-ui/core';

import Loader from 'Elements/Loader';
import { withMeetingContext, MeetingContextDeviceControlsProps } from 'Scenes/_root/meetingContext';
import isEmpty from 'Services/helpers/isEmpty';
import styles from './styles.scss';

class MeetingPreview extends Component {
  constructor(props) {
    super(props);
    const { deviceControls, registerMeetingCallbacks } = props;
    const { video } = deviceControls.getSelectedDeviceIds();

    this.mainVideoRef = React.createRef();
    this.stopVideoPreview = noop;
    this.deregisterMeetingCallbacks = registerMeetingCallbacks('meetingPreview', {
      onSelectedVideoDeviceIdUpdated: this.onVideoDeviceUpdated,
    });
    this.state = {
      videoDeviceId: video,
    };
  }

  componentDidMount() {
    this.beginVideoPreview();
  }

  componentWillUnmount() {
    this.stopVideoPreview();
    this.deregisterMeetingCallbacks();
  }

  onVideoDeviceUpdated = (deviceId) => {
    const { deviceControls } = this.props;
    if (deviceId !== null) {
      deviceControls.videoPreviewStart(this.mainVideoRef.current)
        .then((stopVideoPreview) => {
          this.stopVideoPreview = stopVideoPreview;
        });
    }
    // we're only setting this into state because we want to cause a re-render and .forceUpdate is gross
    this.setState({
      videoDeviceId: deviceId,
    });
  }

  beginVideoPreview = () => {
    const { deviceControls } = this.props;
    const { video } = deviceControls.getSelectedDeviceIds();
    if (video !== null) {
      deviceControls.videoPreviewStart(this.mainVideoRef.current)
        .then((stopVideoPreview) => {
          this.stopVideoPreview = stopVideoPreview;
        });
    }
  };

  render() {
    const { deviceControls } = this.props;
    const { video } = deviceControls.getSelectedDeviceIds();
    return (
      <div className={styles.videoWrapper}>
        <div className={styles.noVideo}>
          { isEmpty(video) ? (
            <Typography variant='body1'>
              No video source detected
            </Typography>
          ) : (
            <Loader />
          )}
        </div>
        <video ref={this.mainVideoRef} className={styles.videoWidth} playsInline/>
      </div>
    );
  }
}

MeetingPreview.propTypes = {
  registerMeetingCallbacks: func.isRequired,
  deviceControls: MeetingContextDeviceControlsProps,
};

export default withMeetingContext(['registerMeetingCallbacks', 'deviceControls'])(MeetingPreview);
